import find from "../public/gifs/find.gif";
import draw from "../public/gifs/draw.gif";
import edit from "../public/gifs/edit.gif";
import del from "../public/gifs/delete.gif";

export const steps = (ref1, ref2) => [
  {
    title: "افزودن زمین",
    description: "با کلیک بر روی این قسمت میتوانید زمین خود را ثبت کنید.",
    nextButtonProps: {
      children: "بعدی",
    },
    target: () => ref1.current,
  },
  {
    title: "لیست زمین‌های شما",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    description:
      "در این قسمت شما میتوانید مشخصات زمین‌های ثبت شده خود را مشاهده نمائید.",
    target: () => ref2.current,
  },
];

export const fieldViewSteps = (ref1, ref2, ref3) => [
  {
    title: " فرم افزودن زمین ",
    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "ابتدا فرم مربوط به قطعه زمین خود را شامل نام قطعه، نوع محصول و ... تکمیل نمائید. ",
   
    target: () => ref1.current,
  },
  {
    title: "تعیین محدوده زمین ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "بعدی",
    },
    description:
      "سپس با استفاده از دکمه تعیین محدوده زمین موقعیت زمین را روی نقشه تعیین کنید. ",
    target: () => ref2.current,
  },
  {
    title: "  تایید و ثبت زمین ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    description:
      "در انتها پس از تکمیل اطلاعات، روی دکمه تایید و ثبت زمین کلیک کنید.",
    target: () => ref3.current,
  },
];

export const mapSteps = (ref1, ref2, ref3, ref4) => [
  {
    title: "یافتن زمین روی نقشه",
    description:
      "ابتدا با استفاده از جستجوی شهر، قطعه زمین خود را روی نقشه پیدا کنید.",
    nextButtonProps: {
      children: "بعدی",
    },
  
    cover: (
      <img
      
        alt="tour.png"
        src={find}
      />
    ),
    target: () => ref1.current,
  },
  {
    title: "  تعیین محدوده زمین ",
    description:
      "سپس روی این دکمه کلیک کرده و حاشیه اطراف قطعه زمین خود را نقطه‌گذاری کنید.",
    nextButtonProps: {
      children: "بعدی",
    },
    prevButtonProps: {
      children: "قبلی",
    },
    cover: (
      <img
        alt="tour.png"
        src={draw}
      />
    ),
    target: () => ref2.current,
  },
  {
    title: "ویرایش محدوده زمین ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "بعدی",
    },
    cover: (
      <img
        alt="tour.png"
        src={edit}
      />),
    description:
      "در صورت نیاز میتوانید با استفاده از این دکمه محدوده اطراف زمین خود را ویرایش کنید.",
    target: () => ref3.current,
  },
  {
    title: " حذف زمین ",
    prevButtonProps: {
      children: "قبلی",
    },
    nextButtonProps: {
      children: "متوجه شدم",
    },
    cover: (
      <img
        alt="tour.png"
        src={del}
      />),
    description:
      "در صورت نیاز میتوانید محدوده زمینی که مشخص کرده اید را با استفاده از این دکمه حذف کنید.",
    target: () => ref4.current,
  },
];
